import { render, staticRenderFns } from "./BrookfieldNewreleaseBanner.vue?vue&type=template&id=5b3c5ccb&scoped=true&"
import script from "./BrookfieldNewreleaseBanner.vue?vue&type=script&lang=js&"
export * from "./BrookfieldNewreleaseBanner.vue?vue&type=script&lang=js&"
import style0 from "./BrookfieldNewreleaseBanner.vue?vue&type=style&index=0&id=5b3c5ccb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c5ccb",
  null
  
)

export default component.exports